import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FloatingButtons from '@/pages/home/components/FloatingButtons';
import Accordion from '@/components/base/Accordion';
import ProgressiveImage from '@/components/base/ProgressiveImage';

const features = [
  { icon: 'ri-timer-flash-line', title: '3–5 Günde Teslimat', desc: 'Acil gönderileriniz için optimize edilmiş güzergah ile kapıdan kapıya 3–5 iş günü.' },
  { icon: 'ri-map-pin-2-line', title: 'Kapıdan Kapıya', desc: "Adresinizden alır, Almanya'da alıcının kapısına kadar teslim ederiz." },
  { icon: 'ri-notification-3-line', title: 'Anlık Bildirim', desc: 'Kargonuz yola çıktığında WhatsApp üzerinden anlık takip ve bildirim alırsınız.' },
  { icon: 'ri-shield-check-line', title: 'Güvenli Paketleme', desc: 'Küçük ve kırılgan kargolar için özel dayanıklı ambalaj ve koruyucu malzeme.' },
];

const faqs = [
  { q: 'Hızlı kargo için maksimum boyut/ağırlık var mı?', a: 'Tek parça için maksimum 150 kg ve 2 m³ sınırı uygulanır. Daha büyük yükler için parsiyel hizmetimizi öneriyoruz.' },
  { q: 'Hangi ürünleri gönderebilirim?', a: 'Elektronik, giyim, gıda (kuru), yedek parça, doküman ve hediye paketleri gönderilebilir. Yasaklı mallar listesi için bize ulaşın.' },
  { q: 'Teslimat garantisi var mı?', a: 'Evet, 3–5 iş günü teslimat garantisi veriyoruz. Gecikmeler olursa bilgilendirme yapıyoruz.' },
  { q: 'Kargom kaybolursa ne olur?', a: 'Tüm hızlı kargo gönderileri sigortalıdır. Kayıp durumunda sigorta prosedürü başlatılır.' },
];

export default function HizliKargoPage() {
  return (
    <main className="font-sans">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-brand-navy overflow-hidden">
        <div className="absolute inset-0">
          <ProgressiveImage
            src="/media/search-image-b35ad2e845.jpg"
            alt="Hızlı Kargo"
            className="object-cover object-top opacity-20"
            priority
          />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-2 mb-6 flex-wrap">
            <Link to="/" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Anasayfa</Link>
            <span className="text-white/30 text-sm">/</span>
            <Link to="/hizmetlerimiz" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Hizmetlerimiz</Link>
            <span className="text-white/30 text-sm">/</span>
            <span className="text-brand-orange text-sm font-medium">Hızlı Kargo</span>
          </div>
          <span className="inline-flex items-center gap-2 bg-brand-orange/20 border border-brand-orange/30 text-brand-orange text-xs font-semibold px-3 py-1 rounded-full mb-5 uppercase tracking-widest">
            <i className="ri-flashlight-line"></i> Hizmet 04
          </span>
          <h1 className="text-white font-heading font-bold text-4xl md:text-5xl mb-6 leading-tight">
            Hızlı Kargo<br />
            <span className="text-brand-orange">Avrupa&apos;nın 27 Ülkesine Ekspres</span>
          </h1>
          <p className="text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">
            Acil gönderileriniz Türkiye&apos;nin her ilinden Avrupa&apos;nın istediğiniz ülkesine 3–5 iş gününde kapıdan kapıya ulaşır. Zamanında teslimatta ödün yok.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a
              href="https://wa.me/905322376576?text=Merhaba%2C%20h%C4%B1zl%C4%B1%20kargo%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></span>
              Fiyat Teklifi Al
            </a>
            <Link
              to="/iletisim"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white/20 text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-send-line text-base"></i></span>
              Form ile Ulaşın
            </Link>
          </div>
        </div>
      </section>

      {/* Visual + Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Avantajlar</p>
              <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-8">Neden Ekspres Kargo?</h2>
              <div className="flex flex-col gap-5">
                {features.map((f, i) => (
                  <div key={i} className="flex items-start gap-4 p-4 rounded-xl border border-gray-100 hover:border-brand-orange/20 transition-all duration-300">
                    <div className="w-11 h-11 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl flex-shrink-0">
                      <i className={`${f.icon} text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-brand-navy font-heading font-bold text-sm mb-1">{f.title}</h3>
                      <p className="text-gray-400 text-sm leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-[380px] md:h-[480px]">
              <ProgressiveImage
                src="/media/search-image-0a3951f599.jpg"
                alt="Hızlı Kargo"
                className="object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 rounded-xl p-4 flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-brand-orange text-white rounded-lg flex-shrink-0">
                    <i className="ri-flashlight-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-brand-navy font-heading font-bold text-sm">3–5 İş Günü Garanti</div>
                    <div className="text-gray-400 text-xs mt-0.5">Avrupa&apos;nın her ülkesine ekspres teslimat</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative rounded-2xl overflow-hidden h-[360px] md:h-[440px]">
              <ProgressiveImage
                src="/media/search-image-e5fd6fd294.jpg"
                alt="Kargo Teslimat Süreci"
                className="object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent pointer-events-none"></div>
            </div>
            <div>
              <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Süreç</p>
              <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-8">Kargonuz Nasıl İlerler?</h2>
              <div className="flex flex-col gap-5">
                {[
                  { day: 'Gün 1', title: 'Kargo Teslimi & Etiketleme', desc: 'Kargonuzu depomuza teslim edin veya adresinizden alalım.', icon: 'ri-inbox-archive-line' },
                  { day: 'Gün 1–2', title: 'Yükleme & Yola Çıkış', desc: 'Günlük ekspres seferlerimize eklenerek kargonuz yola çıkar.', icon: 'ri-truck-line' },
                  { day: 'Gün 3–4', title: 'Gümrük Süreçleri', desc: 'AB gümrük prosedürleri uzman ekibimiz tarafından hızla tamamlanır.', icon: 'ri-file-list-3-line' },
                  { day: 'Gün 4–5', title: 'Teslimat', desc: "Alıcının kapısına teslim edilir, WhatsApp'tan onay mesajı gelir.", icon: 'ri-checkbox-circle-line' },
                ].map((t, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="flex flex-col items-center flex-shrink-0">
                      <div className="w-11 h-11 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl">
                        <i className={`${t.icon} text-lg`}></i>
                      </div>
                      {i < 3 && <div className="w-0.5 h-5 bg-gray-200 mt-1"></div>}
                    </div>
                    <div className="pt-1">
                      <span className="text-brand-orange text-xs font-bold uppercase tracking-widest">{t.day}</span>
                      <h4 className="text-brand-navy font-heading font-semibold text-sm mt-0.5 mb-0.5">{t.title}</h4>
                      <p className="text-gray-400 text-sm leading-relaxed">{t.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="mb-12 text-center">
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">SSS</p>
            <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl">Sık Sorulan Sorular</h2>
            <p className="text-gray-400 text-sm mt-3">Merak ettiklerinizi tıklayarak öğrenin</p>
          </div>
          <Accordion items={faqs} />
        </div>
      </section>

      {/* Other Services */}
      <section className="py-16 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <p className="text-gray-400 text-sm mb-6 font-medium">Diğer Hizmetlerimiz</p>
          <div className="flex flex-wrap gap-3">
            {[
              { label: 'Parsiyel Taşımacılık', href: '/hizmetlerimiz/parsiyel', icon: 'ri-box-3-line' },
              { label: 'Komple Araç', href: '/hizmetlerimiz/komple-arac', icon: 'ri-truck-line' },
              { label: 'Ev & Ofis Taşıma', href: '/hizmetlerimiz/ev-ofis-tasima', icon: 'ri-home-4-line' },
            ].map((s) => (
              <Link
                key={s.href}
                to={s.href}
                className="inline-flex items-center gap-2 border border-gray-200 text-brand-navy hover:border-brand-orange hover:text-brand-orange px-4 py-2.5 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className={`${s.icon} text-base`}></i></span>
                {s.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </main>
  );
}
